export const addLeadingZero = (value: number | string) =>
  Number(value) < 10 ? `0${value}` : `${value}`;
